import React, { useEffect, useState } from "react";
import "./TokenRate.css";
import { ethers } from "ethers";

const TokenRate = ({ contract, account }) => {
  const [stakingHistory, setStakingHistory] = useState([]);

  const handleUnstake = async (index) => {
    try {
      const tx = await contract.unstake(index);
      await tx.wait();
      alert("Unstake successful!");
      fetchStakingHistory(); // Refresh the staking history after unstaking
    } catch (error) {
      alert("Error unstaking: " + error.message);
    }
  };

  const handleClaimReward = async (index) => {
    try {
      const tx = await contract.claimReward(index);
      await tx.wait();
      alert("Reward claimed successfully!");
      fetchStakingHistory(); // Refresh the staking history after claiming rewards
    } catch (error) {
      alert("Error claiming reward: " + error.message);
    }
  };

  const fetchStakingHistory = async () => {
    let history = [];
    let index = 0;
    let continueFetching = true;

    while (continueFetching) {
      try {
        const stake = await contract.stakers(account, index);
        history.push({
          amount: ethers.utils.formatUnits(stake.amount, 18),
          startTime: new Date(stake.startTime * 1000).toLocaleDateString(),
          duration: Math.floor(stake.duration / (30 * 24 * 60 * 60)), // Converts seconds to months, assuming 30 days per month
          active: stake.active,
        });
        index++;
      } catch (error) {
        continueFetching = false; // Stop fetching when an error is thrown
      }
    }

    setStakingHistory(history);
  };

  useEffect(() => {
    if (contract && account) {
      fetchStakingHistory();
    }
  }, [contract, account]);

  return (
    <div className="token-rate">
      <div className="staking-history">
        <h2>Staking History</h2>
        <table>
          <thead>
            <tr>
              <th>Amount</th>
              <th>Start Time</th>
              <th>Duration</th>
              <th>Active</th>
              <th>UnStake</th>
              <th>Claim Reward</th>
            </tr>
          </thead>
          <tbody>
            {stakingHistory.map((item, index) => (
              <tr key={index}>
                <td>{item.amount}</td>
                <td>{item.startTime}</td>
                <td>{item.duration} Months</td>
                <td>{item.active ? "Yes" : "No"}</td>
                <td>
                  <button
                    className="action-button"
                    onClick={() => handleUnstake(index)}
                    disabled={!item.active}
                  >
                    Unstake
                  </button>
                </td>
                <td>
                  <button
                    className="action-button"
                    onClick={() => handleClaimReward(index)}
                    disabled={!item.active}
                  >
                    Claim
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TokenRate;
